import { Component } from '@angular/core';
import { LoginComponent } from '../login.component';

@Component({
  selector: 'app-desktop-login',
  templateUrl: './login.desktop.component.html',
  styleUrls: ['./login.desktop.component.scss']
})
export class LoginDesktopComponent extends LoginComponent {
}


